import { create } from 'zustand';

const STORAGE_KEY = 'knowledgeTooltipSeen';

const useKnowledgeTooltipStore = create((set) => ({
  isOpen: false,
  
  showTooltip: () => {
    set({ isOpen: true });
  },
  
  hideTooltip: () => {
    set({ isOpen: false });
    localStorage.setItem(STORAGE_KEY, 'true');
  },
  
  hasSeenTooltip: () => {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  },
  
  reset: () => {
    set({ isOpen: false });
  }
}));

export default useKnowledgeTooltipStore;

